import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  widgetSettings: {},
  genderType: [],
  treatmentType: [],
  proffesionalDetails: [],
  availabilityDate: [],
  avilabilityTime: [],
  upsaleProducts: [],
  chairDetails: [],
  guestDetails: [],
  combinationsList: [],
  quantities: {},
  selectedGenderType: "",
  selectedTreatmentType: {},
  selectedProffesionalDetails: {},
  selectedDate: "",
  selectedTime: "",
  selectedUpsaleProducts: [],
  selectedChairDetails: {},
  selectedCombinations: [],
  selectedCombinationUpsale:[],
  guestFields: [],
  totalPrice: 0,
  upsaleProductPrice: 0,
  upsaleLoader: false,
  guestLoader: false,
  totalVAT: 0,
  FieldsData: [],
  addFieldsData:[],
  fieldsLoader: false,
  buttonText:'',
  languageWords:{},
  transactionDetails:{},
  langLoader:false,
  widgetLoader:false
};
export const addGuestSlice = createSlice({
  name: "salon",
  initialState,
  reducers: {
    setWidgetSettings: (state, action) => {
      state.widgetSettings = action.payload;
    },
    setGenderType: (state, action) => {
      state.genderType = action.payload;
    },
    setTransactionDetails: (state, action) => {
      state.transactionDetails = action.payload;
    },
    setTreatmentType: (state, action) => {
      state.treatmentType = action.payload;
    },
    setProffesionalDetails: (state, action) => {
      state.proffesionalDetails = action.payload;
    },
    setSelectedCombinationExtraProduct: (state, action) => {
      state.selectedCombinationUpsale = action.payload;
    },
    setAvailabilityDate: (state, action) => {
      state.availabilityDate = action.payload;
    },
    setAvailabilityTime: (state, action) => {
      state.avilabilityTime = action.payload;
    },
    setUpsaleProducts: (state, action) => {
      state.upsaleProducts = action.payload;
    },
    setChairDetails: (state, action) => {
      state.chairDetails = action.payload;
    },
    setGuestDetails: (state, action) => {
      state.guestDetails = action.payload;
    },
    setCombinationsList: (state, action) => {
      state.combinationsList = action.payload;
    },
    setSelectedGenderType: (state, action) => {
      state.selectedGenderType = action.payload;
    },
    setselectedTreatmentTypes: (state, action) => {
      state.selectedTreatmentType = action.payload;
    },
    setselectedProffesionalDetails: (state, action) => {
      state.selectedProffesionalDetails = action.payload;
    },
    setselectedDate: (state, action) => {
      state.selectedDate = action.payload;
    },
    setselectedTime: (state, action) => {
      state.selectedTime = action.payload;
    },
    setselectedUpsaleProducts: (state, action) => {
      state.selectedUpsaleProducts = action.payload;
    },
    setselectedChairDetails: (state, action) => {
      state.selectedChairDetails = action.payload;
    },
    setselectedUpsaleProducts: (state, action) => {
      state.selectedUpsaleProducts = action.payload;
    },
    setselectedChairDetails: (state, action) => {
      state.selectedChairDetails = action.payload;
    },
    setSelectedCombination: (state, action) => {
      state.selectedCombinations = action.payload;
    },
    setQuantities: (state, action) => {
      state.quantities = action.payload;
    },
    setGuestFields: (state, action) => {
      state.guestFields = action.payload;
    },
    setTotalPrice: (state, action) => {
      state.totalPrice = action.payload;
    },
    setUpsaleProductPrice: (state, action) => {
      state.upsaleProductPrice = action.payload;
    },
    setUpsaleLoader: (state, action) => {
      state.upsaleLoader = action.payload;
    },
    setGuestLoader: (state, action) => {
      state.guestLoader = action.payload;
    },
    setTotalVAT: (state, action) => {
      state.totalVAT = action.payload;
    },
    setGetFieldsData: (state, action) => {
      state.FieldsData = action.payload;
    },
    setFieldsLoader: (state, action) => {
      state.fieldsLoader = action.payload;
    },
    setAddFieldsData:(state,action)=>{
      state.addFieldsData=action.payload
    },
    updateButtonText:(state,action)=>{

      state.buttonText=action.payload
    },
    setLanguageWords: (state, action) => {
      state.languageWords = action.payload
    },
    setLangLoader:(state,action)=>{
      state.langLoader=action.payload
    },
    setWidgetLoadet:(state,action)=>{
      state.widgetLoader=action.payload
    }

  },
});
export const {
  setLangLoader,
  setWidgetLoadet,
  setWidgetSettings,
  setGenderType,
  setGetFieldsData,
  setSelectedCombinationExtraProduct,
  setTransactionDetails,
  setTreatmentType,
  setProffesionalDetails,
  setAvailabilityDate,
  setAvailabilityTime,
  setUpsaleProducts,
  setChairDetails,
  setGuestDetails,
  setCombinationsList,
  setSelectedGenderType,
  setselectedTreatmentTypes,
  setselectedProffesionalDetails,
  setselectedDate,
  setselectedTime,
  setselectedUpsaleProducts,
  setselectedChairDetails,
  setSelectedCombination,
  setQuantities,
  setGuestFields,
  setTotalPrice,
  setUpsaleProductPrice,
  setUpsaleLoader,
  setGuestLoader,
  setTotalVAT,
  setFieldsLoader,
  setAddFieldsData,
  updateButtonText,
  setLanguageWords
} = addGuestSlice.actions;

export default addGuestSlice.reducer;
